<template>
  <div class="wrapper"> <a href="/index.html" id="logomark" ><img src="/images/head_logo.jpg" /></a> <a href="/index.html" id="corpttl"><img src="/images/head_corpttl.gif" /></a>
    <div id="lead_text">建設機械レンタルの電動舎です。同業社専門に貸出を行っております。<br>
      確かな整備力と豊富な在庫量が特徴で、吟味したニッチな商品も取り揃えております。</div>
    <div id="global-nav">
      <ul>
        <li><a href="/index.html"><img src="/images/gmenu01_off.jpg" class="imgover" /></a></li>
        <li class="sp-hide"><a href="/products/category.html"><img src="/images/gmenu02_off.jpg" class="imgover" /></a></li>
        <li class="sp-hide"><a href="/recommend/items_list.html"><img src="/images/gmenu03_off.jpg" class="imgover" /></a></li>
        <li class="sp-hide"><a href="/company/office.html"><img src="/images/gmenu04_off.jpg" class="imgover" /></a></li>
        <li class="sp-hide"><a href="/company/information.html"><img src="/images/gmenu05_off.jpg" class="imgover" /></a></li>
        <li class="sp-hide"><a href="/recruitment/fresh.html"><img src="/images/gmenu06_off.jpg" class="imgover" /></a></li>
      </ul>
    </div>
<!--snsアイコンエリア -->  
   <div id="global-nav-sns-area">
      <ul>
               <li><a href="https://www.youtube.com/channel/UCYScC0ycwXCO--PzbWIaobw/videos" title="YouTube 電動舎チャンネル" target="_blank"><img src="/images/icon_youtube.png" alt="Youtube " border="0" ></a></li>
<li><a href="https://instagram.com/dendousya_used_official?igshid=YmMyMTA2M2Y=" title="Instagram 電動舎中古情報" target="_blank"><img src="/images/icon_Instagram.png" ></a></li>
      </ul>
    </div><!--snsアイコンエリア -->  
     
    <!-- global-nav -->
    <div id="sp-gnav">
      <div class="cp_offcm01">
        <input type="checkbox" id="cp_toggle01">
        <label for="cp_toggle01"><span></span></label>
        <div class="cp_menu">
          <ul>
            <li><a href="/index.html">HOME</a></li>
            <li><a href="/products/category.html">商品紹介</a></li>
            <li><a href="/recommend/items_list.html">お勧め商品</a></li>
            <li><a href="/company/office.html">営業所紹介</a></li>
            <li><a href="/company/information.html">会社案内</a></li><br>
            <li><a href="/recruitment/fresh.html">採用情報</a></li>
          </ul>
        </div>
      </div>
      <!-- sp-gnav -->
    </div>
</template>

<script>
  export default {
    data: function (){
      return {
        menu : {
          show: false
        }
      }
    },
    methods: {
      toggleList: function (menu){
        menu.show = !menu.show
      },
      mobileShow: function (status){
        var mq_mode = this.$mq
        if(mq_mode==='pc'){
          return true
        }else{
          return status
        }
      }
    }
  }
</script>

